import { DefaultTheme } from 'styled-components';

import { colors } from '../colors';
import { Theme } from '../types';

const theme3: DefaultTheme = {
  name: Theme.theme3,

  // Text
  fontFamily: `sofia-pro, san-serif`,
  fontColor: colors.deepTeal,
  fontWeight: 400,
  fontSize: '16px',
  fontLineHeight: '30px',
  lineHeight: 'normal',
  errorColor: colors.error,
  iconColor: colors.mossGreen,

  // Button
  buttonFontWeight: 400,
  buttonFocusShadow: `none`,
  buttonPrimaryTextColor: colors.deepTeal,
  buttonPrimaryHoverTextColor: colors.white,
  buttonPrimaryDisabledTextColor: `${colors.deepTeal}60`,
  buttonPrimaryColor: colors.mossGreen,
  buttonPrimaryHoverColor: colors.greatGreen,
  buttonPrimaryDisabledColor: colors.fennel,
  buttonSecondaryBorderColor: colors.deepTeal,
  buttonSecondaryColor: '#222',
  buttonSecondaryBackgroundColor: 'transparent',
  buttonSecondaryHoverColor: colors.deepTeal,
  buttonSecondaryHoverBorderColor: colors.deepTeal,
  buttonSecondaryDisabledColor: `${colors.deepTeal}80`,

  // Checkbox
  checkboxColor: colors.deepTeal,
  checkboxFontWeight: 400,
  checkboxBorderColor: colors.deepTeal,
  checkboxBorderActiveColor: colors.deepTeal,
  checkboxBackgroundColor: colors.white,
  checkboxBackgroundActiveColor: colors.deepTeal,
  checkboxShadow: 'transparent',
  checkboxHover: colors.deepTeal,

  // DatePicker
  datePickerShowOnlyBottomBorder: true,
  datePickerColor: colors.black,
  datePickerBorderColor: colors.deepTeal,
  datePickerPlaceholderColor: colors.geyser,
  datePickerFocusedBorderColor: colors.deepTeal,
  datePickerDisabledColor: colors.darkSilver,
  datePickerIconDisabledColor: colors.darkSilver,
  datePickerActiveColor: colors.mossGreen,
  datePickerHoverActiveColor: colors.mossGreen,
  datePickerHoverShadow: 'none',
  datePickerIconColor: colors.deepTeal,
  datePickerPadding: '7px 16px 5px',
  datePickerCalendarIconPadding: '5px',
  datePickerBackgroundColor: 'transparent',
  datePickerInputHeight: '35px',

  // Dropdown
  dropdownIconColor: colors.deepTeal,

  // Footer
  footerTextColor: colors.robinsEggBlue,
  footerHeadingColor: colors.edgewater,
  footerCheckIconColor: colors.mossGreen,
  footerSocialIconColor: colors.robinsEggBlue,
  footerLineColor: colors.robinsEggBlue,
  footerInputErrorColor: colors.carnelian,
  footerIconColor: colors.deepTeal,
  footerBackgroundDark: colors.deepTeal,
  footerBackgroundLight: '#244547',

  // Form
  formRowLabelColor: colors.deepTeal,
  formRowLabelFontSize: '20px',
  formRowLabelPadding: '0 0 54px 0',
  formRowGap: '54px',

  // Heading
  // sizes: 1, 2, 3, 4, 5, 6, 7
  headingSizes: ['64px', '56px', '36px', '30px', '24px', '20px', '16px'],
  headingLineHeight: ['68px', '60px', '48px', '36px', '30px', '30px', '30px'],
  headingMobileSizes: ['64px', '56px', '36px', '30px', '24px', '20px', '16px'],
  headingOutline: '14px',
  headingOutlineLineHeight: '24px',
  headingFontFamily: `sofia-pro, san-serif`,
  headingFontWeight: '400',

  // Link
  linkColor: colors.deepTeal,
  linkHoverColor: colors.deepTeal,
  linkDisabledColor: colors.fennel,

  // LinkButton
  linkButtonIconColor: colors.mossGreen,
  linkButtonIconColorDisabled: colors.fennel,

  // Modal
  modalLineColor: colors.mossGreen,

  // Nav
  navLinkColor: colors.deepTeal,
  navLinkBackgroundColor: colors.deepTeal,
  navSubMenuItemHoverBackgroundColor: colors.fennel,
  navMenuItemBackgroundColor: colors.fennel,
  navMobileSignInLinkColor: colors.deepTeal,
  navUserIconBackgroundColor: colors.geyser,
  navUserIconColor: colors.deepTeal,
  navMenuHamburgerColor: colors.deepTeal,
  navBorderColor: colors.geyser,

  // Navbar
  navbarColor: colors.deepTeal,
  navbarColorHover: colors.deepTeal,

  // PDF
  pdfControlsColor: colors.mossGreen,
  pdfControlsDisabledColor: colors.fennel,
  pdfIconColor: colors.mossGreen,
  pdfIconDisabledColor: colors.fennel,
  pdfControlsIconColor: `${colors.deepTeal}80}`,

  // Radio
  radioColor: colors.deepTeal,
  radioBorderColor: colors.geyser,
  radioBorderActiveColor: colors.deepTeal,
  radioBackgroundColor: colors.white,
  radioBackgroundActiveColor: colors.deepTeal,
  radioShadow: 'transparent',
  radioHover: colors.deepTeal,
  radioSize: 16,
  radioInputTopPosition: 2,

  // Select Input
  selectShowOnlyBottomBorder: true,
  selectShowIndicatorAnimation: true,
  selectColor: colors.black,
  selectPlaceholderColor: colors.geyser,
  selectDisabledColor: colors.darkSilver,
  selectBorderColor: colors.deepTeal,
  selectPrimaryBorderColor: colors.deepTeal,
  selectPrimaryHoverBorderColor: colors.deepTeal,
  selectPrimaryFocusedBorderColor: colors.deepTeal,
  selectPrimaryDisabledBackgroundColor: 'transparent',
  selectHoverShadow: 'none',
  selectInputPadding: '0 0 0 5px',
  selectInputBackgroundColor: 'transparent',
  selectMenuShadow: '0 2px 4px 0 rgba(217, 217, 217, 0.5)',
  selectMenuBorder: `0`,
  selectOptionPadding: '6px 16px',
  selectOptionActiveColor: colors.deepTeal,
  selectDisabledBorderColor: colors.darkSilver,
  selectIndicatorIcon: 'arrow-down',
  selectIndicatorIconSize: 20,
  selectIndicatorIconViewWidth: 20,
  selectIndicatorIconViewHeight: 20,
  selectIndicatorIconColor: colors.deepTeal,
  selectInputHeight: '36px',

  // Tabs
  tabsActiveColor: colors.deepTeal,
  tabsActiveBorderColor: colors.mossGreen,

  // Text Input
  textInputShowOnlyBottomBorder: true,
  textInputColor: colors.black,
  textInputFocusedColor: colors.black,
  textInputBorderColor: colors.deepTeal,
  textInputFocusedBorderColor: colors.deepTeal,
  textInputBackgroundColor: 'transparent',
  textInputHoverShadow: 'none',
  textInputPadding: '7.5px 16px',
  textInputPlaceholderColor: colors.darkSilver,
  textInputLabelColor: colors.deepTeal,
  textInputNotePadding: '0 16px',
  textInputNoteFontStyle: 'italic',
  textInputDisabledBorderColor: colors.darkSilver,
  textInputDisabledColor: colors.darkSilver,
  textInputShowAnimatedLabel: false,
  textInputIconColor: colors.deepTeal,
  textInputHeight: '36px',

  // Textarea Input
  textAreaInputTextColor: colors.deepTeal,
  textAreaInputBorderColor: colors.deepTeal,
  textAreaInputFocusTextColor: colors.black,
  textAreaInputFocusBorderColor: colors.deepTeal,
  textAreaInputDisabledTextColor: colors.darkSilver,
  textAreaInputDisabledBorderColor: colors.darkSilver,
  textAreaInputPlaceholderColor: colors.darkSilver,

  // Toggle
  toggleColor: colors.geyser,
  toggleActiveColor: colors.mossGreen,

  // UserDropdown
  userDropdownColor: colors.deepTeal,
  userDropdownColorHover: colors.deepTeal,

  inputErrorMessagePadding: '0 16px',
};

export default theme3;
